<template>
  <SenseCreditWidget :args="args" :debug="false" />
</template>

<script>
import SenseCreditWidget from '@/components/credits/SenseCreditWidget.vue'

export default {
  name: 'SenseCreditCheckout',
  components: {
    SenseCreditWidget,
  },
  props: {
    products: {
      type: Array,
      require: true,
      default: () => [],
    },
    form: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  data: () => {
    return {
      args: {},
    }
  },
  beforeMount() {
    this.args.merchandises = this.products.map((product) => ({
      name: product[`name_${this.$i18n.locale}`] || product.name,
      code: product.code,
      price: product.newPrice ? product.newPrice : product.price,
      quantity: 1,
    }))
    this.args.clientPhone = this.form.phone
    this.args.clientMail = this.form.email
    this.args.clientFirstName = this.form.name
  },
}
</script>
